/**
 * Alerts query hook (F12).
 *
 * @see docs/plan/IMPLEMENTATION_PLAN.md task 9.4
 */
import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import type { AlertsResult } from '@nexus/contracts';

import { queryKeys } from '../../../lib/query-keys';

import * as alertsApi from './alerts.api';

export function useAlerts(): UseQueryResult<AlertsResult> {
  return useQuery({
    queryKey: queryKeys.alerts.all,
    queryFn: () => alertsApi.listAlerts(),
  });
}
